module.exports = __webpack_public_path__ + "static/leaveEarly.3f49d413.svg";